<template>
    <Selectable
        v-slot="selectable"
        :value="reason"
        v-model="modelValue"
        @click="updateValue()"
    >
        <Card
            :isActive="selectable.active"
            :shouldHighlightOnHover="true"
        >
            <template #content>
                <div class="space-y-2">
                    <div
                        class="p-2 rounded-lg2 inline-flex"
                        :class="{
                            'bg-white': selectable.active,
                            'bg-primary-shade-ligth': !selectable.active,
                        }"
                    >
                        <Icon
                            :name="iconName"
                            class="w-6 h-6 text-primary"
                        />
                    </div>
                    <div class="text-lg font-bold text-gray-900">
                        {{ title }}
                    </div>
                    <div class="text-sm font-normal text-gray-500">
                        {{ description }}
                    </div>
                </div>
            </template>
        </Card>
    </Selectable>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import Selectable from '@/Shared/Component/Selectable.vue'
    import type { BookingReasonEnum } from '@/Shared/AutoGenerated/Main'

    const modelValue = defineModel<BookingReasonEnum>()

    const props = defineProps({
        reason: {
            type: String as () => BookingReasonEnum,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        iconName: {
            type: String,
            required: true,
        },
    })

    const updateValue = (): void => {
        modelValue.value = props.reason
    }
</script>
